import BaseServiceCrud from './BaseServiceCrud';
import moment from 'moment';
import Constants from '../utils/constants';

export default class EventService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'events';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            dateFrom: criteria.startDate ? moment(criteria.startDate).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            dateTo: criteria.endDate ? moment(criteria.endDate).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
        });
    }

    changeStatus(id, status){
        return this.fetch(`${this.domain}/${this.path}/${id}/${status}`, {
            method: 'PATCH',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
